import type { SVGProps } from 'react'

export const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.615 15.676a8.3 8.3 0 0 1-.713-3.363c0-4.81 4.126-9.23 9.216-9.23s9.216 4.422 9.216 9.23c0 3.044-1.653 5.722-4.157 7.278-5.852 2.608-11.41.98-13.562-3.915"
      fill="#1BD99A"
    />
    <path
      d="M17.348 19.891a.33.33 0 0 1-.284-.158.337.337 0 0 1 .107-.461c2.4-1.484 3.83-3.976 3.83-6.666 0-5.14-4.49-8.981-8.507-8.981s-8.508 3.84-8.508 8.981c0 1.066.22 2.1.655 3.076a.334.334 0 1 1-.61.273 8.2 8.2 0 0 1-.713-3.347c0-4.554 3.925-9.649 9.177-9.649s9.178 5.095 9.178 9.649c0 2.923-1.55 5.627-4.147 7.234a.33.33 0 0 1-.175.05z"
      fill="#000"
    />
    <path
      d="M8.694 10.817a.78.78 0 1 0 0-1.56.78.78 0 0 0 0 1.56M16.407 10.817a.78.78 0 1 0 0-1.56.78.78 0 0 0 0 1.56"
      fill="#000"
    />
    <path
      d="M23.216 8.455a1.57 1.57 0 0 0-.62-1.103l-7.03-5.42C13.812.579 11.248.557 9.472 1.88l-7.12 5.3c-.363.27-.589.658-.637 1.093-.048.426.083.847.37 1.18.583.68 1.647.792 2.372.25l7.122-5.3a1.55 1.55 0 0 1 1.84.015l7.03 5.42c.299.23.676.36 1.06.363h.015c.504 0 .978-.208 1.302-.572.292-.33.431-.747.391-1.174z"
      fill="#000"
    />
    <path
      d="M11.739 20.893c-6.533-.122-7.778-4.421-7.778-4.421-3.539-1.356-1.836-4.046-1.836-4.046-2.211-1.79-.058-4.456-.058-4.456l4.362 2.772"
      fill="#1BD99A"
    />
    <path
      d="M11.903 21.046c-2.023 0-4.268-.426-6.086-1.86-1.292-1.02-1.857-2.147-2.028-2.545-1.17-.477-1.907-1.156-2.194-2.019-.307-.923 0-1.79.196-2.206-1.67-1.575-.685-3.77.1-4.744l.203-.25 3.466 2.58c.148.11.178.32.07.467a.335.335 0 0 1-.468.07L2.226 8.352c-.44.666-1.376 2.455.195 3.726l.231.187-.158.252c-.005.008-.581.945-.26 1.9.232.695.882 1.252 1.933 1.653l.145.056.051.148c.074.208 1.898 5.114 9.853 3.926a.334.334 0 1 1 .1.662c-.731.109-1.551.186-2.41.186z"
      fill="#000"
    />
    <path d="M14.248 10.697a1.7 1.7 0 1 0-3.402-.028l3.4.028z" fill="#EEE47B" />
    <path
      d="M14.246 10.948h-.001l-3.4-.03a.254.254 0 0 1-.249-.253c.005-.521.211-1.01.582-1.375.368-.361.852-.56 1.367-.56h.018a1.956 1.956 0 0 1 1.935 1.967.25.25 0 0 1-.25.249zm-3.127-.528 2.856.024a1.453 1.453 0 0 0-2.447-.796c-.215.212-.356.48-.41.772"
      fill="#000"
    />
    <path d="M10.846 10.671a1.7 1.7 0 1 0 3.402.03l-3.4-.03z" fill="#EEE47B" />
    <path
      d="M12.545 12.636h-.016a1.94 1.94 0 0 1-1.375-.583 1.94 1.94 0 0 1-.56-1.385.25.25 0 0 1 .25-.249h.002l3.4.03c.066 0 .13.027.177.075q.07.074.072.178a1.953 1.953 0 0 1-1.951 1.934zm-1.431-1.713c.048.292.184.563.396.779a1.45 1.45 0 0 0 2.46-.754z"
      fill="#000"
    />
  </svg>
)
